<template>
	<div class="w-100">
<!--		search component-->
		<div class="d-flex justify-content-between align-items-center mb-1">
			<paginate
				:page_id="pagination.bottomId"
				:page_start="pagination.start"
				:page_end="pagination.end"
				:page_limit="pagination.limit"
				:pages_length="pagination.page_length"
				:select_options="[15, 50, 100]"
				:callback_name="pagination.callback_name"
				pageinate_class="d-flex justify-content-between w-100"
				@pageinate_event="$emit('pageinate_event', $event)"
			></paginate>
		</div>
		<div v-if="enable_search===true">
			<div class="row">
				<!--				filter buttons-->
				<div class="col-12 col-md-6 align-self-center">
					<div class="d-flex">
						<div class="btn-group d-flex" data-toggle="buttons">
							<div class="align-self-center">
								<div class="btn btn-sm mr-2"
									 :class="{
										'btn-secondary':filter_type === 'ref',
										'btn-primary':filter_type !== 'ref',
									 }"
									 v-on:click="setFilter('ref')" >
									Ref
								</div>
							</div>
							<div class="align-self-center">
								<div class="btn btn-sm mr-2"
									 :class="{
									 	'btn-secondary':filter_type === 'email',
									 	'btn-primary':filter_type !== 'email',
									 }"
									 v-on:click="setFilter('email')">
									Email
								</div>
							</div>
							<div class="align-self-center">
								<div class="btn btn-sm mr-2"
									 :class="{
										'btn-secondary':filter_type === 'last_name',
										'btn-primary':filter_type !== 'last_name',
									 }"
									 v-on:click="setFilter('last_name')">
									Last Name
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-md-6">
					<div class="d-flex justify-content-between align-content-center">
<!--						search bar-->
						<search-bar
								input_width_class="w-100"
								cls="mb-0 mr-3"
								name="Customer"
								:value="null"
								:close_search_action="true"
								@search_event="$emit('search_event', $event)"
								@execute_search="$emit('searchButton')"
								@close_search_event="$emit('close_search_event', $event)"
						></search-bar>
<!--						search button-->
						<div class="d-flex"><button v-if="search_button"
													v-bind:disabled="disable_button"
													v-on:click="$emit('searchButton')"
													class="m-0 btn btn-primary btn-sm align-self-center">Search</button></div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "BarListCheckinPaginationComponent",
		props: [
			'sale_contents',
			'pagination',
			'enable_search',
			'filter',
			'search_button',
			'disable_button'
		],
		data(){
			return {
				/**
				 * @type {String}
				 */
				filter_type:'ref'
			}
		},
		methods:{
			setFilter(val){
				this.filter_type = val;
				this.$emit('filter',val)
			}
		}
	}
</script>
<style scoped>
	.toggle-filter{
		white-space: nowrap !important;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/navigation/BarListCheckinPaginationComponent.vue?704822bf